import type {
  BetterstartCommandRuntime,
  ListPresetsCommandOptions
} from '@cli-types/core-engine/commands.js'
import { Command } from 'commander'

export function createListPresetsCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('list-presets')
    .description('List available BetterStart presets')
    .option('--json', 'Print presets as JSON on stdout', false)
    .option('--cwd <path>', 'Project root path')
    .action((options: ListPresetsCommandOptions) => runtime.runListPresets(options))
}
